import React, { FC, HTMLAttributes, useEffect, useState } from "react";
import { elactive, elAnchor, elAnchorButton, ElDropMenu, elIsMobile, EllogoImg, EllogoLink, ElMenu, ElMenuDrop, ElMenuItem, ElMenuMobile, ElNavigation, ElNavigationContent } from "./navigation.css";
import { Container } from "../container";
import { Images } from "../../../@assets/images";
import { Drawer } from "../../drawer";
import { Icons } from "../../icons";
import { Link, useParams } from "react-router-dom";
import { cx } from "@linaria/core";

interface INavigationProps extends HTMLAttributes<HTMLElement> {}

export const Navigation: FC<INavigationProps> = ({ children, ...props }) => {
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const { key } = useParams();

  const isActive = (key: string): string => {
    if (window.location.pathname.match(key)) {
      return elactive;
    }
    return "";
  };

  const goTarget = (key: string) => () => {
    const docTarget = document.querySelector(key);
    if (docTarget) {
      docTarget.scrollIntoView({ behavior: "smooth" });
    }
  };

  useEffect(() => {
    if (key) {
      setTimeout(goTarget(`#${key}`), 300);
    }
  }, [key]);

  return (
    <ElNavigation {...props}>
      <Container>
        <ElNavigationContent>
          <ElMenuDrop>
            <Icons icon={"bars"} onClick={() => setIsOpen(true)} />
            <Drawer header={<EllogoImg src={Images.logo} />} canDismiss isOpen={isOpen} onDrawerClose={() => setIsOpen(false)}>
              <ElMenuMobile>
                <ElMenuItem>
                  <span className={cx(elAnchor, isActive("/program"))}>
                    Program <Icons icon={"chevron-down"} />
                  </span>
                  <ElDropMenu>
                    <Link className={cx(elAnchor, isActive("/program-bekup-create"))} to="/program-bekup-create">
                      Bekup Create
                    </Link>
                    <Link className={cx(elAnchor, isActive("/program-bekup-accelerate"))} to="/program-bekup-accelerate">
                      Bekup Accelerate
                    </Link>
                  </ElDropMenu>
                </ElMenuItem>
                <ElMenuItem>
                  <Link className={cx(elAnchor, isActive("/contact"))} to="/contact">
                    Contact
                  </Link>
                </ElMenuItem>
                <ElMenuItem>
                  <Link className={cx(elAnchor, isActive("/about"))} to="/about">
                    About
                  </Link>
                </ElMenuItem>
                <ElMenuItem>
                  <Link className={elAnchorButton} to="/s/program" onClick={goTarget("#program")}>
                    Join BEKUP 2025
                  </Link>
                </ElMenuItem>
              </ElMenuMobile>
            </Drawer>
          </ElMenuDrop>
          <EllogoLink href="/">
            <EllogoImg src={Images.logo} />
          </EllogoLink>
          <ElMenu>
            <ElMenuItem className={elIsMobile}>
              <Link className={cx(elAnchor, isActive("/program"))} to="/program">
                Program
                <Icons icon={"chevron-down"} />
              </Link>

              <ElDropMenu>
                <Link className={cx(elAnchor, isActive("/program-bekup-create"))} to="/program-bekup-create">
                  Bekup Create
                </Link>
                <Link className={cx(elAnchor, isActive("/program-bekup-accelerate"))} to="/program-bekup-accelerate">
                  Bekup Accelerate
                </Link>
              </ElDropMenu>
            </ElMenuItem>
            <ElMenuItem className={elIsMobile}>
              <Link className={cx(elAnchor, isActive("/contact"))} to="/contact">
                Contact
              </Link>
            </ElMenuItem>
            <ElMenuItem className={elIsMobile}>
              <Link className={cx(elAnchor, isActive("/about"))} to="/about">
                About
              </Link>
            </ElMenuItem>
            <ElMenuItem>
              <Link className={elAnchorButton} to="/s/program" onClick={goTarget("#program")}>
                Join BEKUP 2025
              </Link>
            </ElMenuItem>
          </ElMenu>
        </ElNavigationContent>
      </Container>
    </ElNavigation>
  );
};
